export const LeftPosition = 61;
export const Paddings = 8;
